import { apiHelper } from '@appfolio/js-utils-apm';
import { withEnvRoot } from '@tportal/common/utils';
import { TpiParams } from '@tportal/login/types';

export interface ActivationResponse {
  message?: string;
  type?: string;
}

const headers = {
  'Content-Type': 'application/vnd.api+json',
  Accept: 'application/json',
};

export const activate = (
  activationToken: string,
  password: string,
  params?: TpiParams
): any => (
  apiHelper.post(
    withEnvRoot(`/activations/${activationToken}`),
    { user: { password, passwordConfirmation: password, acceptsTermsOfService: true }, ...params },
    { headers }
  )
);
